export default {
  xAxis: {
    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    lineColor: '#c8c8c8',
    min: 0,
    max: 11,
    labels: {
      style: {
        color: '#616161',
        fontSize: '10px',
      },
    },
  },
  yAxis: {
    showLastLabel: true,
    gridLineWidth: 1,
    gridLineColor: '#f3f3f3',
    lineColor: '#c0c0c0',
    lineWidth: 1,
    tickPositions: [0, 25, 50, 75, 100],
    labels: {
      enabled: true,
      style: {
        color: '#616161',
        fontSize: '10px',
        width: '175px',
      },
      formatter() {
        return `${ this.value }%`;
      },
    },
    opposite: false,
    title: {
      text: '',
    },
  },
};
